import { t } from '@kc-console/core';

import type { Region } from '@kc-console/context';
import type { SnackbarInfos } from '../types';

export const getSnackbarInfos = (projectName?: string, currentRegion?: Region): SnackbarInfos => {
  return {
    bad_request_project: {
      // message: () => getI18n().t('snackbars.bad_request_project_msg', { ns: COMMON_NS }),
      message: () => t('ui:guard.snackbar.no_project_msg'),
      key: 'bad_request_project_alert',
    },
    bad_request_region: {
      // message: () => getI18n().t('snackbars.bad_request_region_msg', { ns: COMMON_NS }),
      message: () => t('ui:guard.snackbar.no_region_msg'),
      key: 'bad_request_region_alert',
    },
    change_project: {
      // message: () => getI18n().t('snackbars.change_project_msg', { ns: COMMON_NS, projectName }),
      message: () => t('ui:guard.snackbar.change_project_msg', { projectName }),
      key: 'change_project_alert',
    },
    change_region: {
      // message: () => getI18n().t('snackbars.change_region_msg', { ns: COMMON_NS, currentRegion }),
      message: () => t('ui:guard.snackbar.change_region_msg', { currentRegion }),
      key: 'change_region_alert',
    },
  };
};
